<template>
  <table class="table-list__table" v-if="!isHide">
    <tr>
      <th v-for="(column, i) in columns" :key="i" align="center" class="table-list__th">
        <div class="table-list__cell">{{ column.label }}</div>
      </th>
    </tr>
    <template v-for="(item, k) in data">
      <tr :key="k + 'row-1'">
        <td v-for="(column, j) in columns" :key="j + 'column'" align="center">
          <div class="table-list__cell">{{ column.renderColumn(item) }}</div>
        </td>
      </tr>
      <tr :key="k + 'row-2'">
        <td :colspan="columns.length">
          <div class="table-list__row-end">
            <slot :item="item"></slot>
          </div>
        </td>
      </tr>
    </template>
    <template v-if="data.length === 0">
      <tr>
        <td :colspan="columns.length">
          <div class="table-list__row-end" style="text-align: center; padding: 10px;">
            -- -- -- -- -- -- -- --
          </div>
        </td>
      </tr>
    </template>
    <slot name="last"></slot>
  </table>
</template>

<script>
export default {
  name: 'table-list',
  props: {
    columns: {
      type: Array
    },
    data: {
      type: Array
    },
    hideEmpty: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isHide: function () {
      return this.hideEmpty && this.data.length === 0
    }
  }
}
</script>
